<template>
    <div class="connet">
        <div class="tableBox orderMain">
            <div class="CM_heand">
                <div class="search-row">
                    <div class="searchTime">
                        <el-date-picker v-model="timeRange" type="datetimerange" range-separator="——"
                            start-placeholder="开始日期" end-placeholder="结束日期" @change="chooseTime" :clearable="false"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </div>

                    <div class="searchInput">
                        <el-input placeholder="搜索病历号/用户姓名" v-model="keyword" prefix-icon="el-icon-search"
                            @keyup.enter.native="search">
                        </el-input>
                    </div>

                    <el-button @click="search" type="success">查询</el-button>
                </div>
            </div>

            <div class="orderTable">
                <el-table :data="tableData" :style="{ width: flexWidth + 'px' }" style="min-height: 94%"
                    class="CF_style" v-loading="loading" :cell-class-name="tableRowClassName">
                    <el-table-column label="病历编号" prop="medicalRecordOrderNumber"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="挂号编号" prop="registerNo" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="姓名" prop="userName"></el-table-column>

                    <el-table-column label="诊断" prop="prescrDiagName" :show-overflow-tooltip="true"></el-table-column>

                    <el-table-column label="主诉" prop="allergicHistory" :show-overflow-tooltip="true"></el-table-column>

                    <el-table-column label="医生" prop="doctorName"></el-table-column>
                    <el-table-column label="就诊时间" prop="signTime"></el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div>
                                <el-button type="text" @click="getDetails(scope.row)">详情</el-button>
                                <el-button type="text" @click="handleDownload(scope.row)">下载</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="8"
                layout="total, prev, pager, next" :total="totalCount" class="paginationBox" align="center">
            </el-pagination>
        </div>

        <el-dialog title="病历详情" :visible.sync="dialogVisible" width="70%">
            <div class="medical-detail-content" v-loading="detailLoading">
                <table style="width: 100%; line-height: 32px; margin-bottom: 20px" border="0">
                    <tr>
                        <td width="50%"><span>病历编号：</span><span>{{ detailsData.medicalRecordOrderNumber }}</span></td>
                        <td width="50%"><span>就诊时间：</span><span>{{ detailsData.orderTime }}</span></td>
                    </tr>
                    <tr>
                        <td><span>姓名：</span><span>{{ detailsData.userName }} {{ detailsData.userSex == 1 ? '男' : '女'
                                }}</span>
                        </td>
                        <td><span>年龄：</span><span>{{ detailsData.userAge }}岁</span></td>
                    </tr>
                    <tr>
                        <td><span>身份证号：</span><span>{{ detailsData.idNo }}</span></td>
                        <td><span>电话：</span><span>{{ detailsData.phone }}</span></td>
                    </tr>
                    <tr>
                        <td><span>科室：</span><span>{{ detailsData.deptName }}</span></td>
                        <td><span>医生名称：</span><span>{{ detailsData.doctorName }}</span></td>
                    </tr>
                    <tr>
                        <td><span>地址：</span><span>{{ detailsData.address }}</span></td>
                        <td><span>医院名称：</span><span>{{ detailsData.hospitalName }}</span></td>
                    </tr>

                </table>

                <div class="detail-item-box">
                    <p><strong>主诉：</strong>{{ detailsData.allergicHistory || '无' }}</p>
                    <p><strong>现病史：</strong>{{ detailsData.presentIllness || '无' }}</p>
                    <p><strong>既往史：</strong>{{ detailsData.diseaseHistory || '无' }}</p>
                    <p><strong>过敏史：</strong>{{ detailsData.allergyName || '无' }}</p>
                    <p><strong>手术史：</strong>{{ detailsData.operHistory || '无' }}</p>
                    <p><strong>婚育史：</strong>{{ detailsData.marryHistory || '无' }}</p>
                    <p><strong>家族史：</strong>{{ detailsData.familyHistory || '无' }}</p>
                    <p><strong>家族史：</strong>{{ detailsData.familyHistory || '无' }}</p>
                    <p>
                        <strong>肝功能状态：</strong>
                        {{
                            detailsData.liverFunction === 'NORMAL' ? '正常' :
                                detailsData.liverFunction === 'ABNORMAL' ? '异常' :
                                    detailsData.liverFunction === 'UNKOWN' ? '未知' : '无'
                        }}
                    </p>
                    <p>
                        <strong>肾功能状态：</strong>
                        {{
                            detailsData.renalFunction === 'NORMAL' ? '正常' :
                                detailsData.renalFunction === 'ABNORMAL' ? '异常' :
                                    detailsData.renalFunction === 'UNKOWN' ? '未知' : '无'
                        }}
                    </p>
                </div>
                <h3 class="detail-title">诊断</h3>
                <div class="detail-item-box suggestion-box">
                    {{ detailsData.prescrDiagName }}
                </div>
                <h3 class="detail-title">诊疗意见</h3>
                <div class="detail-item-box suggestion-box">
                    {{ detailsData.treatmentSuggestion }}
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="tipsFlag" width="30%" :show-close="false" :close-on-click-modal="false"
            class="tipsMsgBox" :modal="false">
            <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getMedicalRecordsList,
    getMedicalRecordsDetails,
    downLoadMedicalRecord
} from "../../../api/index";

export default {
    name: "MedicalRecord",
    data() {
        return {
            tableData: [],
            timeRange: [],
            startTime: "",
            endTime: "",
            keyword: "",
            loading: false,
            detailLoading: false,
            dialogVisible: false,
            totalCount: 0,
            currentPage: 1,
            detailsData: {},
            flexWidth: 0,
            screenWidth: 0,
            tipsFlag: false,
            tipsMsg: "",
        };
    },
    created() {
        this.initTime();
        // 自动刷新逻辑复刻
        this.refreshTimer = setInterval(() => {
            this.loadListData();
        }, 600000);
    },
    mounted() {
        this.calculateWidth();
        window.onresize = () => {
            this.calculateWidth();
        };
        this.loadListData();
    },
    destroyed() {
        window.onresize = null;
        if (this.refreshTimer) clearInterval(this.refreshTimer);
    },
    methods: {
        initTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = this.twoDigits(now.getMonth() + 1);
            const day = this.twoDigits(now.getDate());
            this.startTime = `${year}-${month}-${day} 00:00:00`;
            this.endTime = `${year}-${month}-${day} 23:59:59`;
            this.timeRange = [this.startTime, this.endTime];
        },
        twoDigits(val) {
            return val < 10 ? "0" + val : val;
        },
        calculateWidth() {
            this.screenWidth = document.body.clientWidth;
            this.flexWidth = this.screenWidth - 305;
            if (this.flexWidth < 1548) {
                this.flexWidth = 1548;
            }
        },
        chooseTime() {
            if (this.timeRange && this.timeRange.length > 0) {
                this.startTime = this.timeRange[0];
                this.endTime = this.timeRange[1];
            } else {
                this.startTime = "";
                this.endTime = "";
            }
        },
        formatStatus(val) {
            const map = {
                'NORMAL': '正常',
                'ABNORMAL': '异常',
                'UNKOWN': '未知'
            };
            return map[val] || '无';
        },
        loadListData() {
            this.loading = true;
            const params = {
                lz: "8",
                cp: this.currentPage.toString(),
                startTime: this.startTime,
                endTime: this.endTime,
                keyword: this.keyword
            };
            getMedicalRecordsList(params).then((res) => {
                if (res.code == 0) {
                    this.totalCount = res.data.total;
                    this.tableData = res.data.list;
                } else {
                    this.errorTipsMsg(res.msg);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        search() {
            this.currentPage = 1;
            this.loadListData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadListData();
        },
        getDetails(row) {
            this.dialogVisible = true;
            this.detailLoading = true;
            this.detailsData = {};
            const params = {
                medicalRecordOrderNumber: row.medicalRecordOrderNumber
            };
            getMedicalRecordsDetails(params).then((res) => {
                if (res.code == 0) {
                    this.detailsData = res.data;
                } else {
                    this.errorTipsMsg(res.msg);
                }
                this.detailLoading = false;
            }).catch(() => {
                this.detailLoading = false;
            });
        },
        handleDownload(row) {
            const postData = {
                medicalRecordOrderNumber: row.medicalRecordOrderNumber
            };
            downLoadMedicalRecord(postData).then((res) => {
                if (res.code == 0) {
                    // 拼接 Base64 前缀并下载
                    const fileName = `病历_${row.userName}_${row.medicalRecordOrderNumber}.pdf`;
                    const base64Data = "data:application/pdf;base64," + res.data;
                    this.downloadFile(fileName, base64Data);
                } else {
                    this.errorTipsMsg(res.msg);
                }
            });
        },
        downloadFile(file_name, file_path) {
            fetch(file_path)
                .then(res => res.blob())
                .then(blob => {
                    const aLink = document.createElement("a");
                    aLink.download = file_name;
                    aLink.href = URL.createObjectURL(blob);
                    aLink.click();
                    URL.revokeObjectURL(aLink.href);
                });
        },
        tableRowClassName() {
            return "statusLine";
        },
        errorTipsMsg(str) {
            this.tipsFlag = true;
            this.tipsMsg = str;
            setTimeout(() => {
                this.tipsFlag = false;
            }, 2000);
        }
    }
};
</script>

<style scoped>
/* 继承原处方页面样式 */
.connet {
    padding: 1% 2%;
    min-height: 96%;
    background: rgb(245, 246, 250);
}

.connet>.tableBox {
    border-radius: 12px;
    background: #fff;
}

.orderMain {
    box-sizing: border-box;
    padding: 24px 20px;
}

.CM_heand {
    margin-bottom: 24px;
    min-width: 1590px;
}

.search-row {
    display: flex;
    align-items: center;
    gap: 15px;
}

.el-table /deep/ .statusLine .cell {
    line-height: 26px;
}

.statusStyle1 {
    color: #f56c6c;
}

.statusStyle4 {
    color: #0caf60;
}


.tipsMsgBox /deep/ .el-dialog__header {
    display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
    background: #fff;
    color: #0caf60;
    text-align: center;
}

.detail-title {
    font-size: 16px;
    margin: 20px 0 10px 0;
    padding-left: 10px;
    line-height: 1;
}

.detail-item-box {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    line-height: 24px;
}

.detail-item-box p {
    margin: 5px 0;
}

.suggestion-box {}

.medical-detail-content {
    color: #606266;
}
</style>